<template>
  <v-toolbar
    color="white"
    dark
    flat
    fixed
    app
    clipped-right
  >
  <v-layout>
    <!--<v-btn class="hidden-sm-and-down" flat color="blue darken-2" @click="pushTo('/')"><v-icon color="blue lighten-3" medium>fa fa-home</v-icon></v-btn>
      <v-text-field id="inpt_search" class="search mt-2" width="10px" clearable></v-text-field>
    -->
    <!--<v-icon>home</v-icon>-->
   <!-- <v-btn class="hidden-sm-and-down" flat color="blue darken-2" @click="pushTo('/Search')"><v-icon color="blue lighten-3" medium>fa fa-search</v-icon></v-btn> -->
    <v-img src="static/sas_icon.png" max-width="60px" width="60px" max-height="60px" height="60px" @click="pushTo('/')">
    </v-img>
    <v-toolbar-title @click="restart" class="mt-3">
      <span style="color: #6f6f6e;font-weight: 400">surf</span><span
      style="color: #6f6f6e;font-weight: bolder">and</span><span
      style="color: #6f6f6e;font-weight: 400">scan</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu full-width transition="slide-y-transition" color="#6f6f6e" content-class="vmenu" class="hidden-md-and-up mt-2">
      <v-btn icon slot="activator" dark>
        <v-icon color="#6f6f6e" medium>menu</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile>
          <v-list-tile-title color="#6f6f6e" class="menuLink" @click="pushTo('/')">
            Home
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title color="#6f6f6e" class="menuLink">
            <a href='#/page4'>Scannen</a>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title color="#6f6f6e" class="menuLink">
            <a href='#/Search'>Finden</a>
          </v-list-tile-title>
        </v-list-tile>
        <!--
        <v-list-tile>

          <v-list-tile-title color="#6f6f6e" class="menuLink">
            <a href='/Configuration'>Einstellungen</a>
          </v-list-tile-title>
        </v-list-tile>
        -->
        <v-list-tile>
          <v-list-tile-title color="#6f6f6e" class="menuLink">
            <a href="https://edologic.de/Impressum">Impressum</a>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title color="#6f6f6e" class="menuLink">
            <a href="https://edologic.de/Datenschutz">Datenschutz</a>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title color="#6f6f6e" class="menuLink">
            <span @click="logout" class="handpointer">Abmelden</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <!--
    <div class="hidden-sm-and-down cp">
      <label class="search mt-2" for="inpt_search">
        <input id="inpt_search" type="search" />
      </label>
    </div>
    -->

    <v-btn class="hidden-sm-and-down" flat color="#6f6f6e" @click="pushTo('/Configuration')"><v-icon color="6f6f6e" medium>fa fa-cogs</v-icon></v-btn>
    <v-btn class="hidden-sm-and-down" v-if="isCloud" flat color="#6f6f6e" @click="logout"><v-icon color="6f6f6e" medium>fa fa-sign-out</v-icon></v-btn>
  </v-layout>
  </v-toolbar>
</template>

<script>
import Vue from 'vue'
// import $ from 'jquery'
import api from './../login/Login.js'
export default {
  name: 'MainToolbar',
  methods: {
    routeTo (url) {
      window.open(url, '_new')
    },
    restart () {
      this.$router.push('/')
    },
    pushTo (url) {
      this.$router.push(url)
    },
    logout () {
      let cmp = this
      let fnc = function () {
        cmp.$router.push('/login')
      }
      api.doLogout(fnc, fnc)
    }
  },
  data () {
    return {
      isCloud: false
    }
  },
  mounted () {
    this.isCloud = Vue.prototype.$config.isCloud
    /*
    $('#inpt_search').on('focus', function () {
      $(this).parent('label').addClass('active')
    })

    $('#inpt_search').on('blur', function () {
      if ($(this).val().length === 0) {
        $(this).parent('label').removeClass('active')
      }
    })
    var cmp = this
    $('#inpt_search').keyup(function (e) {
      var code = e.which
      if (code === 13) {
        e.preventDefault()
        var value = $('#inpt_search').val()
        $('#inpt_search').val('')
        $(this).parent('label').removeClass('active')
        cmp.$router.push({name: 'PGSearch', params: {searchtext: value}})
      }
    })
    */
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toolbar/MainToolbar.vue